window.Products.HomeDecor.DuvetCover = function() {};
window.Products.HomeDecor.DuvetCover.inherits(window.Products.HomeDecor.HomeDecor);
window.Products.HomeDecor.DuvetCover.id = 86;
window.Products.HomeDecor.DuvetCover.slug = 'duvet-cover';
window.Products.HomeDecor.DuvetCover.has_3d = true;
window.Products.HomeDecor.DuvetCover.has_subproducts = true;
window.Products.HomeDecor.DuvetCover.use_glb = true;
window.Products.HomeDecor.DuvetCover.prototype.designObject = 0;

window.Products.HomeDecor.DuvetCover.prototype.set3dProperties = function(modelViewer) {
	var me = this;

	modelViewer.object.position.y = -0.5;
	
	modelViewer.camera.position.x = 2.4;
	modelViewer.camera.position.y = 5.8;
	modelViewer.camera.position.z = 7.7;

	me.loadEnvMap(function(){
		for(var i = 0; i < modelViewer.object.children.length; i++){
			if(!modelViewer.object.children[i].material) continue;
			modelViewer.object.children[i].material.envMap = me.envMap;
			modelViewer.object.children[i].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
			modelViewer.object.children[i].material.needsUpdate = true;
			modelViewer.object.children[i].material.envMap.needsUpdate = true;
		}

		modelViewer.object.children[me.designObject].material.normalScale.x = 0.75;
		modelViewer.object.children[me.designObject].material.normalScale.y = -0.75;
		
		me.updateThreeTexture(modelViewer);
	});
};

window.Products.HomeDecor.DuvetCover.prototype.setThreeControls = function(controls) {
	controls.minDistance = 7.0;
	controls.maxDistance = 11.0;
};

window.Products.HomeDecor.DuvetCover.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[this.designObject].material.map = modelViewer.texture;
	modelViewer.object.children[this.designObject].material.map.flipY = false;
	modelViewer.object.children[this.designObject].material.needsUpdate = true;
};